  <div class="pcc-field">
    <div class="pcc-field-label">Variable {{id}}</div>
    <div class="pcc-field-value" style="width:300px">
      <dx-select-box
        [dataSource]="variables"
        [searchEnabled]="false"
        (onSelectionChanged)="variableSelectionChanged($event)"
        placeholder="Please Select"
        displayExpr="name"
        valueExpr="value" [(value)]="variable"></dx-select-box>
    </div>
  </div>
  <div style="color:red;padding-bottom:10px;padding-left:20px" *ngIf="errors['range'+id+keys.variable]">{{errors['range'+id+keys.variable]}}</div>

  <lib-number-field
    [quantity]="quantity"
    [min]="minMin"
    [error]="errors['range'+id+keys.min]"
    (valueChange)="min=$event;announceChange()"
    [value]="min"
    [visible]="true"
    [label]="labels[keys.min]">
  </lib-number-field>

  <lib-number-field
    [quantity]="quantity"
    [min]="minMin"
    [error]="errors['range'+id+keys.max]"
    (valueChange)="max=$event;announceChange()"
    [value]="max"
    [visible]="true"
    [label]="labels[keys.max]">
  </lib-number-field>

  <lib-number-field [error]="errors['range'+id+keys.intervals]" (valueChange)="intervals=$event;announceChange()"
    [value]="intervals" [isInteger]="true" [visible]="true" [label]="labels[keys.intervals]"></lib-number-field>

  <div class="pcc-field">
    <div class="pcc-field-label">Logarithmic Spacing</div>
    <div class="pcc-field-value" >
      <dx-check-box [(value)]="log" style="float:left"  (onValueChanged)="announceChange()"></dx-check-box>
    </div>
  </div>

